$(document).ready(function() {
    $('.event-tabs[data-type="tabs"]').each(function() {
        const $container = $(this);
        
        // Handle tab click
        $container.find('.tab-trigger').on('click', function(e) {
            e.preventDefault();
            
            // Get ID of the associated panel
            const targetPanelId = $(this).attr('aria-controls');
            
            // Remove active and show classes
            $container.find('.tab-trigger').removeClass('active');
            $container.find('.tab-panel').removeClass('show');
            
            // Add active and show classes to the clicked tab and its panel
            $(this).addClass('active');
            $container.find(`#${targetPanelId}`).addClass('show');
        });
    });
});